import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import {
	Badge,
	Card,
	Button,
	Col,
	DatePicker,
	Dropdown,
	message,
	Menu,
	Modal,
	Popconfirm,
	Table,
	Tag,
	Upload,
	Input,
	InputNumber,
	List,
	Row,
	Tooltip,
	Icon,
	Checkbox,
	Popover,
	Select,
	Drawer,
	Tabs,
	Spin
} from 'antd';

//  import { Menu, Dropdown, Icon } from 'antd';

import moment from 'moment';
import debounce from 'lodash/debounce';

import { renderMainTags } from './table';

import { API_ENDPOINT, URL_ENDPOINT, SUPPLIER_URL, EEZEE_URL, ADMIN_URL } from '../../index';

import AdditionalChargeButton from './additional-charge-button';
import CreditNoteForm from './creditNoteForm'
import ChangeSupplierButton from "../orders-v3/modal/change-supplier-button";
import DeliveryDiscountButton from "../orders-v3/delivery-discount-button";
import EditLineItemButton from "../orders-v3/edit-line-item-button";
import FakeOrderButton from '../orders-v3/set-fake-order-button';
import NotifyFinanceForm from './notify-finance-form';
import SetAwaitPaymentButton from "../orders-v3/set-await-payment-button";
import QuickbooksBuyerSearch from './quickbooks-buyer-search';
import SupplierManagementPanel from "../orders-v3/modal/supplier-management-panel";
import InternationalShippingInfoButton from './international-shipping-info-button';

import {
	removeActiveOrder,
	setImage,
	updateAdminControls,
	updateEmailCampaigns,
	updateOrderPaymentObject,
} from './actions';

import './modal.css';
import {
    _getCreditNotes,
	_getUser,
	_getOrderStatus,
	_getPurchaseInvoiceData,
	_postAdditionalCharge,
	_postApproveManualPayment,
	_postChangeWebViewLink,
	_postDuplicateCartToHoldingList,
	_postSendCheckStockEmail,
	_postSendRequestReviewEmail,
	_postSetOfflineReferenceNumber,
	_postSetOrderFulfilled,
	_postSetOrderInProgress,
	_postSetRestockDate,
	_postToggleEnterprisePaid,
	_postToggleEnterprisePending,
	_postUpdateLeadTime,
	_postRetrieveSupplierDetails,
	_postUpdateOrderAgent,
	_editShippingAddress,
	_postSetPaymentMethodPaynow,
	_postSetFakeOrder,
	_getOrderData
} from '../../services';

const confirm = Modal.confirm;

const { Item } = Menu;

const { Option } = Select;

const { TabPane } = Tabs;

const { Dragger } = Upload;

// const { Column } = Modal;

const productionEnvString = "production";

export const DOC_ORDER_TYPES = {
	INVOICE: "INVOICE",
	REFUND_RECEIPT: "REFUND_RECEIPT",
	PAYMENT_SLIP: "PAYMENT_SLIP",
	PAYMENT_ADVICE: "PAYMENT_ADVICE",
	PURCHASE_ORDER: "PURCHASE_ORDER",
	PURCHASE_INVOICE: "PURCHASE_INVOICE",
	DELIVERY_ORDER: "DELIVERY_ORDER",
	ORDER_CONFIRMATION: "ORDER_CONFIRMATION"
};

export const getOrderDocumentLink = ({
	cart,
	docOrderType,
	supplierId = false
}) => {

	if (!cart) {
		return;
	}

	const { orderDocuments } = cart;

	if (!orderDocuments || orderDocuments.length == 0) {
		return;
	}

	const orderDocument = orderDocuments.filter( _orderDocument => {

		let match = _orderDocument.type == docOrderType

		if (supplierId) {
			match = match && _orderDocument.supplierId == supplierId;
		}

		return match;

	})[0]

	if (!orderDocument) {
		return;
	}

	return orderDocument.link;

}

export const renderVariantName = (variants) => {

	if (!variants || variants.length === 0) {
		return <div>None</div>;
	}
	
	return (
		<Row style={{ fontSize: 12, color: "#595959" }}>
			{variants.map(
				_variant => (
					<div>
						{_variant.name}: {_variant._set.name}
					</div>
				)
			)}
		</Row>
	);
}


class OrderModal extends React.Component {

	constructor(props) {
		super(props);

		let activeTabKey = "batch";
		const { permissions } = this.props.user.data

		if (permissions.ezFinance) {
			activeTabKey = "finance"
		}

		if (permissions.ezOperations) {
			activeTabKey = "operations"
		}

		this.state = {

			/**
			 * new v3
			 */
			loading: true,

			/**
			 * new v3 end
			 */

			selectedProductIdRandomKey: this.getRandomKey(),

			activeTabKey,

			syncing: false,
			detailsVisibility: false,
			suppliersDetails: [],
			leadTime: false,
			cart: false,

			additionalChargeNotes: false,
			additionalChargeAmount: false,
			additionalChargePopoverVisible: false,

			creditNotePopoverVisible: false,
			notifyFinancePopoverVisible: false,

			admins: this.props.admins,

			uploadFormVisible: false,

			creditNotes:[],

			/**
			 * QUICKBOOKS
			 */
			qbDepositToAccounts: this.props.qbDepositToAccounts,
			qbPaymentMethods: this.props.qbPaymentMethods,
			qbTerms: this.props.qbTerms,

			paymentAdviceActivePaymentMethodId:

				// process.env.NODE_ENV == productionEnvString?
				true ?

					(this.props.qbPaymentMethods["Paypal"] && this.props.qbPaymentMethods["Paypal"].Id) || ''
					:
					(this.props.qbPaymentMethods["Cash"] && this.props.qbPaymentMethods["Cash"].Id) || '',

			paymentAdviceActiveDepositToId:
				// process.env.NODE_ENV == productionEnvString?
				true ?

					(this.props.qbPaymentMethods["UOB Current"] && this.props.qbPaymentMethods["UOB Current"].Id) || ''
					:
					(this.props.qbDepositToAccounts["Inventory"] && this.props.qbDepositToAccounts["Inventory"].Id) || '',

			paymentAdviceDate: false,
			paymentAdviceAmount: 0,

			checkStockProducts: [],
			checkStockSentEmail: [],
			checkStockPopoverVisible: [],
			checkStockEmailSupplierDetails: [],

			selectedProductIds: [],

			changeSupplierProductIds: [],

			cantFulfillProductIds: [],
			cantFulfillPopoverVisible: false,
			cantFulfillPaymentMode: 'refund',
			cantFulfillRefundOnShipping: 0,
			cantFulfillRefundOnDiscount: 0,
			cantFulfillActivePaymentMethodId:
				process.env.NODE_ENV == productionEnvString ?
					(this.props.qbPaymentMethods["Paypal"] && this.props.qbPaymentMethods["Paypal"].Id) || ''
					:
					(this.props.qbPaymentMethods["Cash"] && this.props.qbPaymentMethods["Cash"].Id) || '',

			cantFulfillActiveRefundFromId:
				process.env.NODE_ENV == productionEnvString ?
					(this.props.qbPaymentMethods["UOB Current"] && this.props.qbPaymentMethods["UOB Current"].Id) || ''
					:
					(this.props.qbDepositToAccounts["Inventory"] && this.props.qbDepositToAccounts["Inventory"].Id) || '',

			qbSellerNameType: "companyName",
			quickbooks: false,

			purchaseInvoiceProducts: false,
			purchaseInvoiceTermsId: this.props.qbTerms["Net 30"].Id,

			paymentSlipActiveDepositToId:
				process.env.NODE_ENV == productionEnvString ?
					(this.props.qbPaymentMethods["DBS Current"] && this.props.qbPaymentMethods["DBS Current"].Id) || ''
					:
					(this.props.qbPaymentMethods["ComBank - Online Saver"] && this.props.qbPaymentMethods["ComBank - Online Saver"].Id) || '',

			purchaseInvoiceLink: false,
			paymentSlipLink: false,
			visible: false,

			emailHeader: `Hi  ,\nI would like to order the following item:`,
			emailFooter: 'Kindly quote ex-stock for this item. Greatly appreciated.',

			editShippingAddress: {},

			quickbookBuyerModalVisible: false

		}

		this.handleChangeWebViewLink = debounce(this.handleChangeWebViewLink, 400)
	}

	async componentDidMount() {

		// get order status first as it prevents modal from rendering
		try{
			await this.getAndSetOrderStatus();
		} catch ( e ){
			console.log( e );
		}

		try{

			let a = performance.now();

			await Promise.all([
				this.getAndSetCart(),
				this.getAndSetCreditNotes()
			])

			await this.getAndSetSuppliersDetails();

			let b = performance.now();
			
			setTimeout( () => {

				this.setState({
					loading: false
				});
	
			}, 900 - (b-a) );

	
		} catch ( e ){
			console.log( e );
		}
	}

	render() {
		const { cartId } = this.props;

		if (!cartId) {
			return null;
		}

		return (
			<Modal
				className="item-modal-content"
				width={1500}
				footer={null}
				onCancel={this.handleCloseModal}
				title={this.renderToolbar()}
				visible={cartId ? true : false}
				bodyStyle={{padding: 16}}
			>
				{this.renderModalContents()}
			</Modal>
		)

	}

	renderAllLogsTable = () => {

		const { orderStatusLogs } = this.state.cart

		const groupByLogs = []

		orderStatusLogs.map(_log => {

			if (_log.touched) {
				return
			}

			const d1 = moment(_log.dateCreated)

			const nearLogs = orderStatusLogs.filter((_l, index) => {
				const d2 = moment(_l.dateCreated)

				if (Math.abs(d1.diff(d2, 'minutes')) < 5 && _log.activity == _l.activity) {

					orderStatusLogs[index].touched = true
					return true

				} else {
					return false
				}
			})

			groupByLogs.push({
				activityPretty: nearLogs.reduce((acc, curr) => acc += curr.activityPretty + "<br/>", ""),
				dateCreated: d1,
				activity: _log.activity
			})

		})

		function formatStatus(status) {
			return status.split('_').reduce((acc, curr) => {
				acc += curr.split('')[0] + curr.slice(1).toLowerCase() + ' '

				return acc
			}, '')
		}

		const columns = [{
			title: 'Date',
			dataIndex: 'dateCreated',
			render: (dateCreated) => moment(dateCreated).format("LLLL")
		}, {
			title: 'Activity',
			dataIndex: 'activityPretty',
			render: (activityPretty) => <div dangerouslySetInnerHTML={{ __html: activityPretty }} />
		}, {
			title: "Type",
			dataIndex: 'activity',
			render: (activity) => formatStatus(activity)
		}, {
			title: '',
			dataIndex: 'actionNeeded',
			render: (actionNeeded) => actionNeeded ? <Tag color="red">ACTION REQUIRED</Tag> : ""
		}]

		return (
			<Table
				scroll={{ y: 600 }}
				dataSource={groupByLogs}
				columns={columns}
			/>
		)

	}

	renderDeliveryNote = () => {

		const { cart } = this.state;

		let deliveryNote = cart.deliveryNote;

		let renderNote = () => {
			if( !deliveryNote || deliveryNote.length === 0 ){
				return "-"
			}

			return (
				<Tag color="blue" style={{ maxWidth: "250px" }} >
					<div style={{ whiteSpace: "normal" }}>
						{deliveryNote}
					</div>
				</Tag>
			);
		}

		return (
			<Card 
				style={{ 
					height: "100%",
					borderRadius: 10
				}} 
				bodyStyle={{ 
					padding: 12
				}}>
				<h4>Delivery Note</h4>
				{renderNote()}
			</Card>
		)
	}

	renderDeliveryDiscountButton = () => {
		return (
			<DeliveryDiscountButton
				onConfirm={ this.handleOnSetAwaitPayment }
				cartId={this.state.cart._id}
				/>
		);
	}

	renderSetAsFakeOrderButton = () => {

		const { cart } = this.state

		return (
			<FakeOrderButton
				onConfirm={this.handleOnSetAsFakeOrder }
				cartId={this.state.cart._id}
				fakeOrder={cart.fakeOrder}
				/>
		)
	}

	renderModalContents = () => {

		const { cart } = this.state;
		const user = this.props.user.data;
		const activeShippingKeys = [ "areaCode","companyName","address","building","country","email","hp","name","postalCode","unit"];

		let _confirmCheckoutSuppliers = cart.confirmCheckout;

		if( this.state.loading ){
			return (
				<Row 
					style={{ height: 500}}
					type="flex" 
					align="middle" 
					justify="center">
					<Col>
						<Spin/>
					</Col>
				</Row>
			);
		}

		return(
			<Row>
				
				{/* {this.state.cart.totalPrice && this.renderDeliverySummary()} */}
				{this.renderOrderDetails()}

				<Row style={{ marginBottom: 16 }} type="flex" gutter={16}>
					<Col span={12}>
						{this.renderDeliveryNote()}
					</Col>

					<Col span={12}>
						{this.renderNotifyCoWorkers()}
					</Col>

				</Row>

				<Row>
					<Col>
						<div className="actions-container">
							<style dangerouslySetInnerHTML={{
								__html: `
						
							.all-logs-drawer .ant-drawer-body{
								background: white;
								padding: 0px;
							}

						`}} />
							<Tabs
								activeKey={this.state.activeTabKey}
								// defaultActiveKey={1} 
								onChange={(key) => this.setState({ activeTabKey: key })}
								type="card">
								<TabPane
									disabled={!this.props.user.data.permissions.ezOperations}
									tab="Operations" key="operations">
									<Row type="flex" gutter={8}>

										<Col>
											{this.renderRestockEmailButton()}
										</Col>
										<Col>
											<Popover
												title="Confirm Invoice Email"
												trigger="click"
												visible={this.state.visible}
												onVisibleChange={this.handleVisibleChange}
												content={
													<Col>
														<Input.TextArea
															rows={5}
															defaultValue={this.state.emailHeader}
															onChange={(e) => this.setState({ emailHeader: e.target.value })} />
														<Input.TextArea
															rows={5}
															defaultValue={this.state.emailFooter}
															onChange={(e) => this.setState({ emailFooter: e.target.value })} />

														<Row type="flex" gutter={8} style={{ marginTop: '10px' }}>
															<Col>
																<Button onClick={this.hide}>
																	Close
															</Button>
															</Col>
															<Col>
																<Button onClick={() => this.sendInvoiceConfirmation()}>
																	Send
															</Button>
															</Col>
														</Row>
													</Col>
												}>
												<Button disabled={true}>Confirm Invoice Email</Button>
											</Popover>

										</Col>
										<Col>
											{this.renderDuplicateHoldingListButton()}
										</Col>
										<Col>
											{cart.orderStatusLogs &&
												<Drawer
													className="all-logs-drawer"
													closable={false}
													onClose={() => this.setState({ logDrawerVisible: false })}
													placement="top"
													visible={this.state.logDrawerVisible}
												>
													{this.state.logDrawerVisible && this.renderAllLogsTable()}
												</Drawer>}
											<Button
												onClick={() => this.setState({ logDrawerVisible: true })}
											>View All Logs</Button>
										</Col>
										<Col>
											<Popover
												placement="left"
												trigger="click"
												title="Change Shipping Address"
												content={
													<Col type="flex" justify="space-between" align="centre">
														{
															activeShippingKeys.map(key => {
																if (key != "_id" && key != "additionalShippingCharges") {
																	return (
																		<Row type="flex" justify="space-between" style={{ marginTop: "15px" }}>
																			<Col style={{ marginRight: "15px" }}>
																				{`${key}:`}
																			</Col>
																			<Col>
																				{
																					key === "address" ?

																						<Input.TextArea
																							value={this.state.editShippingAddress[key]}
																							onChange={(e) => this.editShippingAddress(e, key)}
																						/>
																						:
																						<Input
																							value={this.state.editShippingAddress[key]}
																							onChange={(e) => this.editShippingAddress(e, key)}
																						/>
																				}
																			</Col>
																		</Row>
																	)
																}
															})
														}
														<Row type="flex" justify="end" style={{ marginTop: "15px" }}>
															<Button onClick={() => this.saveShippingAddress()}>
																Save
														</Button>
														</Row>
													</Col>
												}
											>
												<Button onClick={() => this.toggleEditShippingAddress()}>
													Edit Shipping Address
												</Button>
											</Popover>
										</Col>
										<Col>
											{this.renderNotifyFinanceForRefund()}
										</Col>
										{ this.state.cart.deliveryOption === 'international' &&
											<Col>
													<InternationalShippingInfoButton 
														cartId={this.state.cart._id}
														internationalShippingInfo={{
															incoterms: this.state.cart.incoterms,
															netWeight: this.state.cart.netWeight,
															grossWeight: this.state.cart.grossWeight,
															dimension: this.state.cart.dimension,
															totalBox: this.state.cart.totalBox,
														}}
															/>
											</Col>
										}
										{this.renderPayNowApproval(cart)}
									</Row>
								</TabPane>
								<TabPane
									disabled={!this.props.user.data.permissions.ezFinance}
									tab="Finance" key="finance">
									<Row type="flex" gutter={8}>
										<Col>
											{this.renderPaymentAdviceButton()}
										</Col>
										<Col>
											<AdditionalChargeButton cartId={this.state.cart._id} />
										</Col>
										<Col>
											{this.renderCreditNoteButton()}
										</Col>
										<Col>
											{this.renderDeliveryDiscountButton()}
										</Col>
										<Col>
											{this.renderSetAsFakeOrderButton()}
										</Col>
									</Row>
								</TabPane>
								<TabPane tab="Batch" key="batch">
									<Row type="flex" gutter={8}>

										{
											user.permissions.ezOperations && (
												<Col>
													<ChangeSupplierButton 
														onConfirm={ this.onChangeSupplier }
														key={ this.state.selectedProductIdRandomKey }
														cartId={this.state.cart._id}
														productOrderIds={ this.state.selectedProductIds }
														/>
												</Col>	
											)
										}
									
										<Col>
											<EditLineItemButton
												onConfirm={ this.handleOnEditLineItem }
												key={ this.state.selectedProductIdRandomKey }
												cartId={this.state.cart._id}
												productOrderIds={ this.state.selectedProductIds }
												/>
										</Col>

										<Col>
											<SetAwaitPaymentButton
												onConfirm={ this.handleOnSetAwaitPayment }
												key={ this.state.selectedProductIdRandomKey }
												cartId={this.state.cart._id}
												productOrderIds={ this.state.selectedProductIds }
												/>
										</Col>

										<Col>
											{this.renderSelectAllProductsCheckbox()}
										</Col>
									</Row>
								</TabPane>
							</Tabs>
						</div>
					</Col>
				</Row>

				{
					_confirmCheckoutSuppliers.map((_supplier, supplierIndex) => {

						let productOrders = _supplier.products
						let supplierDetails = this.state.suppliersDetails[supplierIndex]
						const { permissions } = this.props.user.data

						return (
							<SupplierManagementPanel
								
								key={ _supplier.supplierId }

								getAndSetSuppliersDetails={ () => this.getAndSetSuppliersDetails() }

								updateOrderModalCart={ this.updateCart }
								onSelectProductOrder={ this.handleAddSelectedProducts }
								selectedProductIds={ this.state.selectedProductIds }

								creditNotes={ this.state.creditNotes }
								orderStatus={ this.state.orderStatus }
								cart={ this.state.cart }
								user={ this.props.user }

								qbDepositToAccounts={this.props.qbDepositToAccounts}
								qbExpenseAccounts={this.props.qbExpenseAccounts}
								qbTerms={this.props.qbTerms}

								adminPermissions={ permissions }
								productOrders={ productOrders }
								supplier={ _supplier }
								supplierIndex={ supplierIndex }
								supplierDetails={ supplierDetails }
								/>
						)

					})
				}

			</Row>
		);

	}

	renderOrderKeyInfo = () => {

		const { cart, orderStatus } = this.state;

		return (
			<Row type="flex" gutter={8} align="middle">
				{renderMainTags(cart, orderStatus )}

				{// Allow Finance to set as Paynow order if 
					// paymethod === '' && admin is finance
					cart.paymentMethod === '' && this.props.user.data.permissions.ezFinance &&
					<Col>
						<Button
							size="small"
							type="primary"
							onClick={() => this.handleSetAsPaynowOrder({ cartId: cart._id })}>
							Set as Paynow Order</Button>
					</Col>
				}

				{
					cart.activeShipping.country !== "SG" && (
						<Col>
							<a
								style={{ fontSize: 14, fontWeight: 500 }}
								target={`country-check-${cart.activeShipping.country}`}
								href={`https://countrycode.org/${cart.activeShipping.country}`}>
								What country is this?
							</a>
						</Col>
					)
				}

				<Col>
					{cart.userNotifications &&
						cart.userNotifications.settings.notifications.sms
						&& cart.userNotifications.settings.notifications.sms.subscribeOrderNotifications
						&& <Tag>Subscribed SMS, HP Verified = {cart.userNotifications.verifiedHp ? 'true' : 'false'}</Tag>}
				</Col>
			</Row>
		);

	}

	renderCustDetails = () => {

		const { cart, quickbookBuyerModalVisible } = this.state;
		const { user } = cart;

		return (
			<Row>
				<div>
					<div style={{display:'grid', gridTemplateColumns: '1fr 4fr'}}>
						<div>Cust Email:</div>
						<div>{user.local.email}</div>
					</div>
					<div style={{display:'grid', gridTemplateColumns: '1fr 4fr'}}>
						<div>Cust Company:</div>
						<div>{user.details.companyName}</div>
					</div>
					<div style={{display:'grid', gridTemplateColumns: '1fr 4fr'}}>
						<div>Cust Quickbooks:</div>
						<div>
							{user.quickbooks && user.quickbooks.buyer && user.quickbooks.buyer.displayName}
							<Button style={{marginLeft: 4}} type="primary" size="small" onClick={() => this.setState({ quickbookBuyerModalVisible: true })}>Change Quickbooks Name</Button> 
						</div>
					</div> 
						
				</div>
				<Modal title="Change Quickbooks Customer" visible={quickbookBuyerModalVisible} footer={false} onCancel={() => this.setState({ quickbookBuyerModalVisible: false })}>
					<QuickbooksBuyerSearch 
						onConfirm={(user) => {
							this.updateCart({user})
							this.setState({ quickbookBuyerModalVisible: false })
						}}
						order={cart}
						/>
				</Modal>

			</Row>
		)

	}

	renderOrderIncharge = () => {

		const { cart } = this.state;

		if (!cart.claimed) {
			return null;
		}

		return (
			<Row gutter={8}>
				<Col>
					<div style={{ marginBottom: 4, marginLeft: 8 }}>
						Order Incharge:{" "}
						<Select
							defaultValue={cart.agent ? cart.agent._id : null}
							style={{ width: 150 }}
							onChange={this.handleChangeOrderInCharge}>

							{this.state.admins && this.state.admins.map(_admin => {

								if (!_admin.permissions.ezOperations) {
									return null;
								}

								return (
									<Select.Option
										value={_admin._id}>
										{_admin.details.name}
									</Select.Option>
								);

							}).filter(truthy => truthy)}

						</Select>
					</div>
				</Col>
			</Row>
		)

	}

	renderToolbar = () => {

		if( this.state.loading ){
			return null;
		}

		return (
			<div>
				<Row type="flex" justify="start" align="middle" gutter={12}>
					<Col>
						{this.renderOrderIncharge()}
						{this.renderOrderKeyInfo()}
					</Col>

					<Col>
						{this.renderCustDetails()}
					</Col>
					
					<Col style={{ marginLeft: 'auto', marginRight: 28 }}>
						<Row type="flex" gutter={8}>

							<Col>
								{this.renderPurchaseOrderButton()}
							</Col>

							<Col>
								{this.renderOrderConfirmationButton()}
							</Col>
							<Col>
								{this.renderInvoiceButton()}
							</Col>
							<Col>
							{ this.state.cart.deliveryOption === 'international' && this.renderCommericalInvoiceButton()}
							</Col>
							<Col>
								<Button
									target={`Scheduler - ${this.state.cart.adminControls.offlineReferenceNumber}`}
									href={`${ADMIN_URL}/delivery/scheduler?query=${this.state.cart.adminControls.offlineReferenceNumber}`}
								>
									Show on Scheduler
								</Button>
							</Col>
						</Row>
					</Col>
				</Row>
			</div>
		)
	}
	renderSelectAllProductsCheckbox = () => {
		return (
			<Row style={{ height: "100%" }} type="flex" align="middle">
				<Checkbox
					onChange={this.handleSelectAllProducts}
				>
					Select all
				</Checkbox>
			</Row>
		)
	}

	renderSummaryCard = ({ number, text, currency, borderColor = null }) => {
		return (
			<Card
				bodyStyle={{
					padding: 12
				}}
				style={{
					borderRadius: 10,
					borderColor
				}}
			>
				<Row type="flex" justify="center" align="middle" gutter={8}>
					<Col>
						<Row type="flex" justify="center">
							<span className="summary-number">{currency} {number}</span>
						</Row>
						<Row type="flex" justify="center">
							<span
								style={{ textAlign: "center" }}
							>{text}</span>
						</Row >
					</Col>
				</Row>
			</Card>
		)
	}

	renderDocumentsDropdown = (cart) => {

		const menu = (
			<Menu
				onClick={(e) => {
					if (e.key === "invoice") {
						this.setState({ documentsDropdownVisible: false });
					}
				}}
			>
				<Item key="paymentAdvice">
					{/* {this.renderUploadPaymentAdviceModal()} */}
					{cart.uploadedDocuments.paymentAdvice && cart.adminControls.qbPaymentId ?
						<Button>
							Payment Advice
					</Button>
						:
						// this.state.uploadFormVisible?
						// this.renderUploadForm()
						// :
						<Popover
							content={this.renderUploadForm}
						>
							<Button
							// onClick={() =>this.setState({uploadFormVisible:true})}
							> Payment Advice</Button>
						</Popover>
						// <Upload
						// withCredentials
						// action={`${URL_ENDPOINT}/api/admin/order-docs/upload-payment-advice/${this.state.cart._id}/${this.props.user.data.details.name}/${this.props.user.data._id}`}
						// onChange={ (info) => this.handleOnChangeUploadPaymentAdvice(info) }
						// >
						// 	<a
						// 		type="default">Payment Advice</a> 
						// </Upload>
					}
				</Item>
				<Item key="invoice">
					<a href={`${API_ENDPOINT}/api/orders/invoice/${cart._id}/${cart.agent && cart.agent._id}`} target={`inv/${cart._id}	`}>Invoice</a>
				</Item>
			</Menu>
		);

		return (
			<Dropdown
				overlay={menu}
				trigger={['click']}
				visible={this.state.documentsDropdownVisible}
				onVisibleChange={(flag) => this.setState({ documentsDropdownVisible: flag })}
			>
				<Button>Documents</Button>
			</Dropdown>
		)
	}

	renderPaymentAdviceUploadForm = () => {
		const { qbPaymentMethods, qbDepositToAccounts } = this.state

		return (
			<div >
				<Row type="flex" justfiy="start">
					Payment Method
			</Row>
				<Row style={{ marginBottom: 8 }} type="flex" justify="center">
					<Select
						placeholder="Payment Method"
						value={this.state.paymentAdviceActivePaymentMethodId}
						onChange={(val) => this.setState({ paymentAdviceActivePaymentMethodId: val })}
						style={{ width: 150 }}>
						{Object.keys(qbPaymentMethods).map(_key =>
							<Option value={qbPaymentMethods[_key].Id}>
								{qbPaymentMethods[_key].Name}
							</Option>
						)}
					</Select>
				</Row>
				<Row type="flex" justfiy="start">
					Deposit to
				</Row>
				<Row style={{ marginBottom: 8 }} type="flex" justify="center">
					<Select
						value={this.state.paymentAdviceActiveDepositToId}
						placeholder="Deposit to"
						onChange={(val) => this.setState({ paymentAdviceActiveDepositToId: val })}
						style={{ width: 150 }}>
						{Object.keys(qbDepositToAccounts).map(_key =>
							<Option value={qbDepositToAccounts[_key].Id}>
								{qbDepositToAccounts[_key].Name}
							</Option>
						)}
					</Select>
				</Row>
				<Row type="flex" justfiy="start">
					Payment Date
				</Row>
				<Row style={{ marginBottom: 8 }} type="flex" justify="center">
					<DatePicker
						style={{ width: 150 }}
						onChange={(date) => this.setState({ paymentAdviceDate: date })}
					/>
				</Row>
				<Row type="flex" justfiy="start">
					Amount
				</Row>
				<Row style={{ marginBottom: 8 }} type="flex" justify="center">
					<InputNumber
						style={{ width: 150 }}
						value={this.state.paymentAdviceAmount}
						onChange={(amount) => this.setState({ paymentAdviceAmount: amount })}
						precision={2}
						step={0.01}
					/>
				</Row>
				<Row style={{ marginBottom: 8 }} type="flex" justify="center">
					<Upload
						withCredentials
						data={{
							date: JSON.stringify(moment(this.state.paymentAdviceDate).unix()),
							paymentMethodId: JSON.stringify(this.state.paymentAdviceActivePaymentMethodId),
							accountId: JSON.stringify(this.state.paymentAdviceActiveDepositToId),
							uploadedBy: JSON.stringify(this.props.user.data.details.name),
							amount: JSON.stringify(this.state.paymentAdviceAmount)
						}}
						action={`${URL_ENDPOINT}/api/admin/order-docs/upload-payment-advice/${this.state.cart._id}/${this.props.user.data._id}`}
						onChange={(info) => this.handleOnChangeUploadPaymentAdvice(info)}
					>
						<Button
							style={{ width: 150 }}
							disabled={!this.state.paymentAdviceActivePaymentMethodId || !this.state.paymentAdviceActiveDepositToId}
							type="primary">Upload</Button>
					</Upload>
				</Row>
			</div>
		)
	}

	renderOrderDetails = () => {

		const { cart } = this.state;

		const addressKeys = [
			{ name: 'companyName', span: 3 },
			{ name: 'email', span: 3 },
			{ name: 'address', span: 3 },
			{ name: 'name', span: 1 },
			{ name: 'hp', span: 1 },
			{ name: 'country', span: 1 },
			{ name: 'building', span: 1 },
			{ name: 'unit', span: 1 },
			{ name: 'postalCode', span: 1 },
		]

		const spanStyle = {gridColumn: '2 / span 3'}
		const borderStyle = { border: '1px solid black', borderRadius: 4}

		let shippingAddressContent = [] 
		addressKeys.map(_addressKey => {
			shippingAddressContent.push(<div><b>{`${_addressKey.name}:`}</b></div>)
			shippingAddressContent.push(<div style={ _addressKey.span===3 ?  spanStyle  : {} }>{`${cart.activeShipping && cart.activeShipping[_addressKey.name] || '-'}`}</div>)
		})

		let billingAddressContent = [] 
		addressKeys.map(_addressKey => {
			billingAddressContent.push(<div><b>{`${_addressKey.name}:`}</b></div>)
			billingAddressContent.push(<div style={ _addressKey.span===3 ?  spanStyle  : {} }>{`${cart.activeBilling && cart.activeBilling[_addressKey.name] || '-'}`}</div>)
		})

		return (
			<Row type="flex" justify='space-around' gutter={16} style={{marginBottom: 8}}>
				{/** Order Info */}
				<Col style={{...borderStyle}} span={5}>
					<h4>Order Info</h4>
					<div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gridColumnGap: 2, gridRowGap: 2}}>
						<div><b>refNumber:</b></div>
						<div>{cart.refNumber}</div>	
						<div><b>offlineRef:</b></div>
						<div>{cart.adminControls.offlineReferenceNumber}</div>	
						<div><b>poRefNumber:</b></div>
						<div>{cart.poRefNumber}</div>	
						<div><b>cartId:</b></div>
						<div>{cart._id}</div>	
					</div>					
				</Col>
				{/* Shipping Info */}
				<Col style={{...borderStyle}} span={9}>
					<h4>Shipping Info</h4>
					<div style={{ display: 'grid', gridTemplateColumns: 'repeat(1fr, 4)', gridColumnGap: 2, gridRowGap: 2}}>
						{shippingAddressContent}
					</div>
				</Col>
				{/* Billing Info */}
				<Col style={{...borderStyle}} span={9}>
					<h4>Billing Info</h4>
					<div style={{ display: 'grid', gridTemplateColumns: 'repeat(1fr, 4)', gridColumnGap: 2, gridRowGap: 2}}>
						{billingAddressContent}
					</div>
				</Col>

			</Row>
		)

	}

	renderDeliverySummary = () => {

		const { cart } = this.state;

		let deliveryPrice = cart.totalPrice.shipping + cart.totalPrice.deliveryWaived //how much the customer is charged

		return (
			<Row type="flex" gutter={16} style={{ marginBottom: 16 }}>
				<Col span={6}>
					{this.renderSummaryCard({
						number: 0,
						currency: cart.currency,
						text: "deliveries scheduled(todo)"
					})}
				</Col>
				<Col span={6}>
					{this.renderSummaryCard({
						number: 0,
						currency: cart.currency,
						text: "deliveries fulfilled(todo)"
					})}
				</Col>
				<Col span={6}>
					{this.renderSummaryCard({
						number: 0,
						currency: cart.currency,
						text: "cost of all deliveries(todo)"
					})}
				</Col>
				<Col
					span={6}>
					{this.renderSummaryCard({
						number: deliveryPrice,
						text: "amount charged for delivery",
						currency: cart.currency,
						borderColor: deliveryPrice < 0 ? "#f5222d" : null
					})}
				</Col>
			</Row>
		)

	}

	renderDuplicateHoldingListButton = () => {
		return (<Button disabled={this.state.duplicatingHoldingList} onClick={this.handleDuplicateHoldingList}>
			Duplicate Holding List
		</Button>)
	}

	renderPurchaseOrderButton = () => {

		const link = getOrderDocumentLink({
			docOrderType: DOC_ORDER_TYPES.PURCHASE_ORDER,
			cart: this.state.cart
		});

		return (
			link ?
				<a
					target="_blank"
					href={link}>
					<Button
						className="fulfilled-button">
						Purchase Order
					</Button>
				</a>
				:
				<Upload
					withCredentials
					action={`${URL_ENDPOINT}/api/admin/order-docs/upload-purchase-order/${this.state.cart._id}/${this.props.user.data._id}`}
					onChange={(info) => this.handleOnChangeUploadPurchaseOrder(info)}
				>
					<Button
					> Purchase Order</Button>
				</Upload>
		)

	}

	renderOrderConfirmationButton = () => {

		const link = getOrderDocumentLink({
			cart: this.state.cart,
			docOrderType: DOC_ORDER_TYPES.ORDER_CONFIRMATION
		})

		if (!link) {
			return (
				<Button
					disabled={true}>
					Order Confirmation</Button>
			)
		}

		return (
			<Button
				className="fulfilled-button"
				href={link}
				target={`inv/${this.state.cart._id}`}>
				Order Confirmation</Button>
		)

	}

	renderInvoiceButton = () => {

		const { cart } = this.state

		const link = getOrderDocumentLink({
			docOrderType: DOC_ORDER_TYPES.INVOICE,
			cart
		});

		if (!link) {
			return (
				<Button
					disabled={true}>
					Invoice</Button>
			)
		}

		return (
			<Button
				className="fulfilled-button"
				href={link}
				target={`inv/${this.state.cart._id}`}>
				Invoice</Button>
		)

	}

	renderCommericalInvoiceButton = () => {

		const { cart } = this.state

		if (cart.deliveryOption !== 'international') {
			return null
		}

		const link = `${API_ENDPOINT}/api/orders/commercial-invoice/${cart._id}/commercial-invoice`;

		return (
			<Button
				className="fulfilled-button"
				href={link}
				target={`_blank`}>
				Commercial Invoice</Button>
		)

	}

	renderPaymentAdviceButton = () => {

		const link = getOrderDocumentLink({
			docOrderType: DOC_ORDER_TYPES.PAYMENT_ADVICE,
			cart: this.state.cart
		});

		return (
			link ?
				<a
					target="_blank"
					href={link}>
					<Button
						className="fulfilled-button">
						Payment Advice
					</Button>
				</a>
				:
				<Popover
					trigger="click"
					placement="bottom"
					content={this.renderPaymentAdviceUploadForm()}
				>
					<Button
					> Payment Advice</Button>
				</Popover>
		)

	}

	renderCreditNoteButton = () => {
		return (
			<Popover
				visible={this.state.creditNotePopoverVisible}
				content={(
					<CreditNoteForm
						closePopover={this.closeCreditNotePopover}
						cartId={this.state.cart._id}
					/>)}
				trigger="click">
				<Button
					disabled={true}
				// onClick={() =>this.setState({creditNotePopoverVisible:!this.state.creditNotePopoverVisible})} 
				>
					Credit Note
				</Button>
			</Popover>
		)
	}

	renderNotifyCoWorkers = () => {

		const { cart } = this.state;

		let notifyCoWorkers = cart.notifyCoWorkers || [];

		let renderTable = () => {

			if( notifyCoWorkers.length === 0 ){
				return "-";
			}

			return (
				<Table 
					bodyStyle={{ border: "0px" }}
					style={{ border: "0px" }}
					bordered={false}
					size="middle"
					rowKey={"_id"}
					pagination={false}
					columns={[
						{
							title: "Name",
							dataIndex: "name"
						},
						{
							title: "Email",
							dataIndex: "email"
						},
						{
							title: "HP",
							key: "contactNumber",
							render: ( text, record, index ) => {

								return (
									<span>
										+{record.contactNumberCountryCode} {record.contactNumber}
									</span>
								)

							}
						}
					]}
					dataSource={notifyCoWorkers}/>
			)

		}

		return (
			<Card 
				style={{ 
					height: "100%",
					borderRadius: 10
				}} 
				bodyStyle={{ 
					padding: 12
				}}>
				<h4>Notify Customer's Co Workers:</h4>
				{renderTable()}
			</Card>
		);

	}

	
	renderNotifyFinanceForRefund = () => {
		return (
			<Popover
				visible={this.state.notifyFinancePopoverVisible}
				content={(
					<NotifyFinanceForm
						closePopover={this.closeNotifyFinancePopover}
						cartId={this.state.cart._id}
						offlineReferenceNumber={this.state.cart.adminControls.offlineReferenceNumber}
						refNumber={this.state.cart.refNumber}
					/>)}
				trigger="click">
				<Button
					onClick={() => this.setState({ notifyFinancePopoverVisible: !this.state.notifyFinancePopoverVisible })}
				>
					Notify Finance
				</Button>
			</Popover>
		)
	}

	renderInProgressMsg = () => {

		const { cart } = this.props;

		if (!cart.adminControls || cart.adminControls.inProgress) {
			return (
				<span>
					<Badge status="processing" />
					In Progress
				</span>
			)
		}

		return (
			<span>
				<Badge status="success" />
				Fulfilled
			</span>
		)

	}



	renderPayNowApproval = (cart) => {

		if (cart.paymentMethod !== "paynow") {
			return null;
		}

		if (cart.payment && cart.payment.approved && cart.payment.approverUserId) {
			return (
				<Col>
					<Tag color="gold">Payment Approver: {this.props.adminUserIdEmailMap[cart.payment.approverUserId]}</Tag>
				</Col>
			)
		}

		if (!cart.payment || !cart.payment.approved) {
			return (
				<Col>
					<Popconfirm
						onConfirm={this.handleApprovePaynow}
						okText="Confirm"
						cancelText="Cancel"
						title="Are you sure? This action is e-reversible. Your user id is logged."
					>

						<Button>
							<a>Confirm Paid via PayNow</a>
						</Button>

					</Popconfirm>
				</Col>
			)
		}

		return null;

	}

	renderPopconfirmFulfilledMsg = () => {

		const { cart } = this.props;

		if ((!cart.adminControls || cart.adminControls) && cart.adminControls.inProgress) {
			return "Set order fulfilled?";
		}

		return "Set order in progress?";

	}

	renderRestockEmailButton = () => {

		const sentRestockReminderEmail = (this.state.cart.lastContact && this.state.cart.lastContact.sentRestockReminderDate) ? true : false;


		let checkoutDate = moment(this.state.cart.checkOutDate);
		let today = moment();

		let restockOptions = [
			{ value: 0.5, text: "14 days" },
			{ value: 1, text: "1 month" },
			{ value: 2, text: "2 months" },
			{ value: 3, text: "3 months" },
			{ value: 4, text: "4 months" },
			{ value: 6, text: "6 months" },
			{ value: 9, text: "9 months" },
			{ value: 12, text: "1 year" },
			{ value: 12 * 2, text: "2 year" },
			{ value: 12 * 5, text: "5 year" }
		];

		restockOptions = restockOptions.filter(option => {

			if (option.value === 0.5) {

				if (moment(checkoutDate).add(14, 'days').isAfter(today)) {
					return true;
				} else {
					return false;
				}

			} else if (moment(checkoutDate).add(option.value, 'months').isAfter(today)) {
				return true;
			} else {
				return false;
			}


		})



		if (sentRestockReminderEmail) {
			return (
				<Tooltip
					placement="top"
					title={"Restock Reminder sent on " + moment(this.state.cart.lastContact.sentRestockReminderDate).format('ll')}>
					<Button disabled={true}>
						Send Restock Email
					</Button>
				</Tooltip>
			);
		}
		return (
			this.renderRestockReminderButton(restockOptions, sentRestockReminderEmail)
		)
	}

	renderRestockReminderButton = (restockOptions, sentRestockReminderEmail) => {
		return (
			<Dropdown
				overlay={(
					<Menu>
						{restockOptions.map(month => {
							return (
								<Item onClick={() => this.handleSelectRestockDate(month.value)}>
									{month.text}
								</Item>
							)
						})}
					</Menu>
				)}>
				<div>
					<Tooltip
						title={this.renderRestockReminderMsg()}>
						<Button type={this.state.cart.emailCampaigns && this.state.cart.emailCampaigns.sendRestockReminderDate ? "danger" : "default"} disabled={sentRestockReminderEmail}>
							{/* {this.renderRestockReminderMsg()} */}
					Send Restock Email
				</Button>
					</Tooltip>
				</div>
			</Dropdown>
		)
	}

	renderSupplierDropdown = () => {

		return (
			<Select>

			</Select>
		)

	}

	renderRestockReminderMsg = () => {

		if (!this.state.cart.emailCampaigns || !this.state.cart.emailCampaigns.sendRestockReminderDate) {
			return "Please select a restock date";
		}

		if (this.state.cart.lastContact && this.state.cart.lastContact.sentRestockReminderDate) {
			return `Restock Reminder sent on ${moment(this.state.cart.lastContact.sentRestockReminderDate).format('ll')}`
		}

		return `Restock reminder scheduled to send on ${moment(this.state.cart.emailCampaigns.sendRestockReminderDate).format('ll')}`

	}

	checkFulfillment = (record) => {

		const { cart } = this.state

		let productId = record.product._id

		let product = cart.totalPrice.products.filter(_product => _product._id === productId)[0]

		console.log(product)

		return product.orderStatus.cantFulfill

	}

	closeAdditionalChargePopover = () => {
		this.setState({ additionalChargePopoverVisible: false })
	}

	closeCreditNotePopover = () => {
		this.setState({ creditNotePopoverVisible: false })
	}

	closeNotifyFinancePopover = () => {
		this.setState({ notifyFinancePopoverVisible: false })
	}

	editShippingAddress = (e, key) => {
		let value = e.target.value
		let address = { ...this.state.editShippingAddress }

		address[key] = value

		this.setState({
			editShippingAddress: address
		})

	}

	formatPriceNumber = (number) => {
		let formattedPriceNumber;

		if (number < 0) {
			formattedPriceNumber = `-S$${Math.abs(number).toFixed(2)}`
		} else {
			formattedPriceNumber = `S$${number.toFixed(2)}`
		}

		return formattedPriceNumber
	}

	getAndSetCart = async ( ) => {

		return new Promise( async ( resolve, reject ) => {

			try{

				let cartResponse = await _getOrderData( this.props.cartId );
				let cart = cartResponse.data.order;
	
				this.setState({
					cart
				}, () => {
					resolve();
				})
	
			} catch( e ){
				reject( e );
			}
	
		});		

	}

	getAndSetCreditNotes = async () => {

		return new Promise( async ( res, rej) => {

			try{

				let cartId = this.props.cartId;
				let creditNoteResponse = await _getCreditNotes({ cartId });
		
				this.setState({
					creditNotes: creditNoteResponse.data.creditNotes
				}, ( ) => {
					res();
				});
	
			} catch ( e ){
				message.error( e.toString() );
				rej( e );
			}
	
		});

	}


	getAndSetOrderStatus = async ( ) => {

		return new Promise( async ( resolve, reject ) => {

			try{

				let orderStatusResponse = await _getOrderStatus({ cartId: this.props.cartId });
				let orderStatus = orderStatusResponse.data.orderStatus;
	
				this.setState({
					orderStatus
				}, () => {
					resolve();
				})
	
			} catch( e ){
				reject( e );
			}
	
		});

	}
	
	getAndSetSuppliersDetails = async ( tmpCart ) => {

		return new Promise( async ( res, rej ) => {

			try{
				const cart = tmpCart || this.state.cart;
	
				let supplierQuery = [];
				
				cart.confirmCheckout.map((_cc, index) => {
		
					supplierQuery.push({
						supplierId: _cc.supplierId,
						index
					});
		
					return _cc;
		
				});
		
				let retrieveSupplierDetailsResponse = await _postRetrieveSupplierDetails({ suppliers:supplierQuery });
				let suppliersDetails = [];
		
				retrieveSupplierDetailsResponse.data.suppliersDetails.map(_supplierDetails => {
					suppliersDetails[_supplierDetails.index] = _supplierDetails;
					return _supplierDetails;
				});
		
				this.setState({ suppliersDetails }, () => {
					res();
				});

			} catch( e ){
				rej( e );
			}
	
		});

	}
	
	getRandomKey = () => {
		return  parseInt(Math.random() * 10000);
	}

	getUpdatedQuantity = (ccProduct, cart) => {

		const productId = ccProduct.product._id

		let updatedQuantity = ccProduct.quantity
		// console.log(updatedQuantity)

		cart.deliveries.map(_delivery => {
			_delivery.products.map(_products => {

				const { product } = _products

				if (product._id === productId) {
					updatedQuantity = updatedQuantity - _products.quantity
				}

				return _products;

			});

			return _delivery;
		});
		// console.log(updatedQuantity)
		return updatedQuantity
	}

	handleOnChangeLeadTime = (date, productCheckoutId) => {

		if (date) {
			_postUpdateLeadTime({
				cartId: this.state.cart._id,
				leadTime: date._d,
				productCheckoutId
			})
				.then(res => {
					if (res) {
						// console.log(res)
						this.setState({ order: res.data.cart })
						message.success("Lead time updated!")
					}
				})
		}
	}

	handleDuplicateHoldingList = () => {

		this.setState({ duplicatingHoldingList: true });

		_postDuplicateCartToHoldingList({ cartId: this.state.cart._id })
			.then(res => {

				message.success("Duplicate holding list created");
				this.setState({ duplicatingHoldingList: false });

			})

	}

	handleDuplicateHoldingList = () => {

		this.setState({ duplicatingHoldingList: true });
		_postDuplicateCartToHoldingList({ cartId: this.state.cart._id })
			.then(res => {

				message.success("Duplicate holding list created");
				this.setState({ duplicatingHoldingList: false });
			})
	}

	handleSetAsPaynowOrder = ({ cartId }) => {
		_postSetPaymentMethodPaynow({ cartId })
			.then(_data => {
				this.setState({
					order: _data.data.cart
				})
			})
	}
	
	handleChangeWebViewLink = ({ value, id, type }) => {

		const { cart } = this.state

		_postChangeWebViewLink({
			type,
			webViewLink: value,
			id,
			orderId: cart._id
		})
			.then(res => {
				message.success("Successfully changed!")
				this.updateCart(res.data.cart)
			})
			.catch(err => message.error("Error!"))
	}

	handleSelectAllProducts = (e) => {

		let { activeTabKey, cart } = this.state

		let selectedProductIds;

		if (e.target.checked) {

			selectedProductIds = cart.products.filter(_product => _product.orderStatus.cantFulfill !== true)
				.map(_product => _product._id)

		} else {
			selectedProductIds = []
		}

		if (activeTabKey !== 'batch') {
			this.setState({ activeTabKey: 'batch' })
		}

		this.setState({ 
			selectedProductIdRandomKey: this.getRandomKey(),
			selectedProductIds
		})

	}

	handleApprovePaynow = () => {

		message.loading('Approving PayNow Payment..', 0);

		const { cart } = this.state;

		_postApproveManualPayment({ cartId: cart._id, instantInvoice: false })
			.then(res => {

				message.destroy();
				message.success("PayNow Payment approved!");

				this.setState({
					cart: {
						...this.state.cart,
						payment: {
							...res.data.payment
						}
					}
				});

				this.props.updateOrderPaymentObject(res.data.payment);

			})
	}

	handleAddSelectedProducts = (e, productId) => {

		let { selectedProductIds, activeTabKey } = this.state

		if (e.target.checked) {
			selectedProductIds.push(productId)
		} else {
			selectedProductIds = selectedProductIds.filter(_productId => _productId !== productId)
		}

		if (activeTabKey !== 'batch') {
			this.setState({ activeTabKey: 'batch' })
		}

		this.setState({ 
			selectedProductIdRandomKey: this.getRandomKey(),
			selectedProductIds 
		})

	}

	handleAddProductToCantFulfill = (e, productId) => {

		let { cantFulfillProductIds } = this.state

		if (e.target.checked) {
			cantFulfillProductIds.push(productId)
		} else {
			cantFulfillProductIds = cantFulfillProductIds.filter(_productId => _productId !== productId)
		}

		this.setState({ cantFulfillProductIds })

	}

	handleSetOrderProgressState = () => {

		let loadingMsg = message.loading("Setting order fulfilled..");
		let inProgress = true;

		const { cart } = this.props;

		if (cart.adminControls && !cart.adminControls.inProgress) {
			inProgress = false;
		}

		if (inProgress) {
			_postSetOrderFulfilled({ cartId: this.props.cartId })
				.then((res) => {

					loadingMsg();

					message.success("Order Fulfilled");

					this.props.updateAdminControls(res.data.adminControls);

				})
		} else {
			_postSetOrderInProgress({ cartId: this.props.cartId })
				.then((res) => {

					loadingMsg();

					message.success("Order Set to In Progress");

					this.props.updateAdminControls(res.data.adminControls);

				})
		}

	}

	handleSelectRestockDate = (month) => {

		const loadingMsg = message.loading('loading...');

		_postSetRestockDate({
			month,
			cartId: this.props.cartId
		})
			.then(res => {

				let { cart } = this.state
				cart.emailCampaigns = res.data.emailCampaigns

				this.updateCart(cart);

				loadingMsg();
				message.success(`Set restock reminder date to ${moment(res.data.emailCampaigns.sendRestockReminderDate).format('ll')}`)

			})
			.catch(e => {
				alert('Error.. Please contact tech support.');
			});

	}

	hide = () => {
		this.setState({
			visible: false,
		});
	};

	handleVisibleChange = visible => {
		this.setState({ visible });
	};

	handleTogglePaid = (modal) => {

		confirm({
			title: 'Are you sure payment has been made?',
			content: 'This action cannot be undone.',
			onOk() {
				console.log('OK');
				modal.setState({ paid: true })
				_postToggleEnterprisePaid({ cartId: modal.props.cartId })
			},
			onCancel() {
				console.log('Cancel');
			},
		})

	}

	handleChangeOrderInCharge = (value) => {
		_postUpdateOrderAgent(this.state.cart._id, value)
			.then(res => {
				if (res.data.success) {
					message.success("Agent changed!")
					this.setState({ order: res.data.cart })
				}
				if (!res.data.success) {
					message.error("Error changing agent!")
				}
			})
			.catch(err => message.error("Error changing agent!"))
	}

	handleOnChangeUploadPurchaseOrder = (info) => {

		if (info.file.status === "done" && info.file.response.success) {

			const { cart, orderDocuments } = info.file.response
			message.success(`Purchase Order uploaded for ${this.state.cart.adminControls.offlineReferenceNumber}`)

			// console.log(info)
			this.updateCart({
				...cart,
				orderDocuments
			})
		}

		if (info.file.status === "error") {
			console.log({ info })
			message.error(`Error uploading purchase order for ${this.state.cart.adminControls.offlineReferenceNumber}`, 10)
			message.error(`${info.file.response.statusmsg}`, 10)
		}
	}

	handleOnChangeUploadPaymentAdvice = (info) => {

		if (info.file.status === "done" && info.file.response.success) {

			const { cart, orderDocuments } = info.file.response
			message.success(`Payment Advice uploaded for ${this.state.cart.adminControls.offlineReferenceNumber}`)

			// console.log(info)
			this.updateCart({
				...cart,
				orderDocuments
			})
		}

		if (info.file.status === "error") {
			console.log({ info })
			message.error(`Error uploading payment advice for ${this.state.cart.adminControls.offlineReferenceNumber}`, 10)
			message.error(`${info.file.response.statusmsg}`, 10)
		}
	}

	handleCloseModal = () => {
		this.props.history.push(`/${this.props.location.pathname.split("/")[1]}`);
		this.props.removeActiveOrder();
	}

	handleMessage = () => {
		if (!this.state.syncing) {
			message.destroy();
			message.loading('syncing', 0);
			this.setState({ syncing: true });
		}
	}

	handleOnChangeUploadState = (uploadObj, product) => {

		if (uploadObj.file.status === 'done') {

			message.success('Uploaded Image');

			// console.log( 'blockchain', uploadObj );
			this.props.setImage(product, uploadObj.file.response)

			// const loadingMsg = this.imageUploading[0];

			// this.imageUploading.shift();
			// loadingMsg();

			// message.success('Image uploaded sucessfully!');
			// this.props.addImageToProduct(info.file.response.productImage)
		}

	}

	handleOnEditLineItem = async ( orderStatus ) => {

		setTimeout( async () => {

			await this.getAndSetCreditNotes();

			this.setState({
				orderStatus,
				selectedProductIdRandomKey: this.getRandomKey()
			});
	
		}, 800);

	}

	handleOnSetAwaitPayment = ( orderStatus ) => {
			
		this.setState({
			orderStatus, 
			selectedProductIdRandomKey: this.getRandomKey()
		});

	}

	handleOnSetAsFakeOrder = () => {

		const { cart } = this.state

		console.log("SETTING AS FAKE ORDER")
		_postSetFakeOrder({ cartId: cart._id })
		.then(res => {
			if (res.data.success) {
				message.success(`${cart.adminControls.offlineReferenceNumber} set as Fake Order!`)
				this.updateCart( res.data.cart )
			} else {
				message.error("Failed set order as Fake!")
			}
		})

	}

	onChangeSupplier = ( cart ) => {

		this.updateCart( cart );
		this.getAndSetSuppliersDetails( cart );
		this.resetSelectedProducts();

	}

	resetSelectedProducts = () => {

		this.setState({ 
			selectedProductIdRandomKey: this.getRandomKey(),
			selectedProductIds: [] 
		})

	}

	saveShippingAddress = () => {
		_editShippingAddress({
			cartId: this.state.cart._id,
			address: this.state.editShippingAddress
		})
			.then((res) => {

				message.success("Address Updated");

				this.setState({
					cart: {
						...this.state.cart,
						activeShipping: res.data.activeShipping
					}
				});
			})
	}

	updateCart = ( cart ) => {
		
		this.setState({
			cart: {
				...this.state.cart,
				...cart
			}
		});

	}

	submitAdditionalCharge = () => {

		_postAdditionalCharge(this.state.cart._id, this.state.additionalChargeAmount, this.state.additionalChargeNotes)
			.then(res => {
				if (res.data.success) {
					message.success(`Successfully added an additional charge of ${this.state.additionalChargeAmount}`)
					this.setState({ order: res.data.cart })
				} else {
					message.error("Failed to add additional charge!")
				}
			})

	}

	sendInvoiceConfirmation = () => {
		console.log(this.state.emailHeader + '\n\n' + this.state.emailFooter)
	}
	
	toggleEditShippingAddress = () => {
		let address = { ...this.state.cart.activeShipping }

		this.setState({
			editShippingAddress: address
		})
	}

}

export default connect(
	state => ({
		adminUserIdEmailMap: state.admins.userIdEmailMap,
		user: state.user
	}),
	dispatch => ({
		removeActiveOrder: () => dispatch(removeActiveOrder()),
		setImage: (product, image) => dispatch(setImage(product, image)),
		updateEmailCampaigns: (emailCampaigns) => dispatch(updateEmailCampaigns(emailCampaigns)),
		updateAdminControls: (adminControls) => dispatch(updateAdminControls(adminControls)),
		updateOrderPaymentObject: (payment) => dispatch(updateOrderPaymentObject(payment)),
	})
)(withRouter(OrderModal));



// WEBPACK FOOTER //
// ./src/components/orders-v2/modal.js